import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-button-skip',
  templateUrl: './button-skip.component.html',
  styleUrls: ['./button-skip.component.less']
})
export class ButtonSkipComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
